import {Component, Inject, Input, OnInit} from '@angular/core';
import {PadTransitTimeComponent} from "./pad-transit-time/pad-transit-time.component";
import {UpdateTransitTimeComponent} from "./update-transit-time/update-transit-time.component";
import {UpdateTransitTimeS3Component} from "./update-transit-time-s3/update-transit-time-s3.component";
import { RemoveLaneTransitTimeUpdateComponent } from './remove-lane-transit-time-update/remove-lane-transit-time-update.component';
import {CommonUtils} from "../../../utils/common.utils";

@Component({
  selector: 'app-update-requests',
  templateUrl: './update-requests.component.html',
  styleUrls: ['./update-requests.component.scss']
})
export class UpdateRequestsComponent implements OnInit {
  @Input('pageData') pageData;
  desiredComponent: any = UpdateTransitTimeComponent;
  selected = 0;

  constructor(
    @Inject('CommonUtils') private readonly commonUtils: CommonUtils
  ) {
  }

  ngOnInit() {
  }


  assignComponent(component) {
    if (component === 'updateTransitTimeComponent') {
      this.selected = 0;
      this.desiredComponent = UpdateTransitTimeComponent;
    } else if (component === 'padTransitTimeComponent') {
      this.selected = 2;
      this.desiredComponent = PadTransitTimeComponent;
    }
    else if (component === 'updateTransitTimeS3Component') {
      this.selected = 3;
      this.desiredComponent = UpdateTransitTimeS3Component;
    }
    else if (component === 'RemoveLaneTransitTimeUpdateComponent') {
      this.selected = 4;
      this.desiredComponent = RemoveLaneTransitTimeUpdateComponent;
    }
  }

}
